import { LocationCity } from '@mui/icons-material'
import LocationFeatureList from './LocationFeatureList'
import LocationFeatureEdit from './LocationFeatureEdit'
import LocationFeatureCreate from './LocationFeatureCreate'

const locationIndex = {
  icon: LocationCity,
  list: LocationFeatureList,
  edit: LocationFeatureEdit,
  create: LocationFeatureCreate,
}

export default locationIndex
